import assign from 'lodash/assign';
import reduce from 'lodash/reduce';

const actions = [
  'UPDATE_APP',
  'UPDATE_PAYMENT_INFO',
  'UPDATE_PAYMENT_SETTINGS',
  'ADD_DEBUG',
  'EDIT_LISTINGS',
  'SET_AUTO_COMPLETE_ADDRESS_LIST',
];

const dispatchConstants = reduce(
  actions,
  (accumulator, value) => {
    accumulator[value] = value;
    return accumulator;
  },
  {},
);

const valueConstants = {
  GA_SCOPE_PAGE: 3,
  GA_SCOPE_SESSION: 2,
};

const constants = assign({}, dispatchConstants, valueConstants);

export default constants;
